import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// componenets and helpers
import { CaseInfo } from '../Case/CaseInfo';
import * as caseActions from '../Case/CaseActions';
import Dashboard from './Dashboard';
import { DashboardContext } from '@acoer/ac-js-lib-charts';

// Material-UI
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material';

// ui reflection of file view
export const DashboardWrapper = (props: { match?: any; view?: any }) => {
    const location = useLocation();
    const { view } = props;
    const theme = useTheme();
    const dispatch = useDispatch();
    const [area, setArea] = useState<string>('');
    const [tabValue, setTabValue] = useState(0);
    const areaConfigs = useSelector((state: any) => state.areaConfigs);
    const selectedCase = useSelector(
        (state: any) => state.cases.selectedCaseId
    );

    const getAreaConfigValues = async (areaConfigs: any) => {
        if (
            areaConfigs &&
            Object.values(areaConfigs)[0] &&
            Object.values(areaConfigs)[0]['dashboard-configuration'] &&
            Object.values(areaConfigs)[0]['dashboard-configuration'].tabs
        ) {
            return Object.values(areaConfigs)[0]['dashboard-configuration'].tabs
                .length;
        }
        return 0;
    };

    useEffect(() => {
        const fetchAreaConfigValues = async () => {
            const areaConfigValues = await getAreaConfigValues(areaConfigs);
            const urlParams = new URLSearchParams(location.search);
            const currentTab = urlParams.get('tab');

            if (currentTab === 'case_list' && areaConfigValues > 0) {
                setTabValue(areaConfigValues - 1);
            }

            const areaId = location.pathname.split('/').pop();
            setArea(areaId);
        };

        fetchAreaConfigValues();
    }, [areaConfigs, location.search, dispatch, location.pathname]);

    const handleCloseCase = () => {
        // const caseListTab = utils.findAllByKey(areaConfigs[area], 'tabs');
        setTabValue(3);
        dispatch(caseActions?.resetSelectedCase());
    };

    const renderCase = () => (
        <CaseInfo
            area={area}
            caseId={selectedCase}
            cases={undefined}
            files={undefined}
            width={undefined}
            handleCloseCase={() => handleCloseCase()}
        />
    );

    return (
        <Grid container id={'workspace-analytics'}>
            {!selectedCase ? (
                <DashboardContext.Provider
                    value={{
                        area: location.pathname.split('/').pop(),
                        view,
                        type: 'case',
                        mode: theme.palette.mode,
                        tabValue: tabValue,
                        setTabValue: setTabValue,
                    }}
                >
                    <Grid container>
                        <Grid item xs={12}>
                            <Dashboard />
                        </Grid>
                    </Grid>
                </DashboardContext.Provider>
            ) : (
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    spacing={3}
                >
                    <Grid item xs={12}>
                        {renderCase()}
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
};

export default DashboardWrapper;
